import { Box, TextField, Typography, Button, Modal } from "@mui/material"
import { useState, useEffect } from "react"
import CameraModal from "./CameraModal"
import BarcodeScanner from "../../../BarcodeScanner";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { isNumeric } from "../../../../../../core/global/Format";

export const Setup = ({products,open, setOpen, setProducts, info, setInfo, snackBarLoader, setSnackBarLoader, modal, setModal})=>{

    const [item, setItem] = useState({
        name: "",
        barcode: "",
        price: 0,
        quantity: 1,
        uom: 'pc',
        image: null
    })

    const [preview, setPreview] = useState(null)
    const [scannerOpen, setScannerOpen] = useState(false)

    const handleChange = (e, type)=>{
        e.preventDefault()
        if(type === "branch_name"){
            setInfo((prev)=>({...prev, [type]: e.target.value}))
            return
        }else if(type === "price" && !isNumeric(e.target.value) && e.target.value !==""){
            return
        }
        setItem((prev)=>({...prev, [type]: e.target.value}))
    }

    const handleBarcodeScanned = (barcode) => {
        setItem((prev) => ({ ...prev, barcode: barcode }))
        setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Barcode scanned: ${barcode}`, type: 'success'})
    }

    const handleAddProduct = ()=>{
        if (item.name === '') {
            setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Add Product Name!`, type: 'error'})
            return
        } else if (item.price === 0 || !isNumeric(item.price)) {
            setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Invalid Price`, type: 'error'})
            return
        }
        setModal(false)
        setProducts((products) => [...products, item])
    }

    useEffect(() => {
        setItem({        
            name: "",
            barcode: "",
            price: 0,
            quantity: 1,
            uom: 'pc'
        })
        setPreview(null)
    }, [products]);

    return(
        <Modal open={modal} onClose={()=>{setModal(false)}} sx={{p:2, display: "flex", alignItems: "center"}}>
            
            <Box sx={{p: 3, display: "flex", flexDirection: "column", gap: 2, justifyContent: "space-between", bgcolor: "#fff", width: "100%", borderRadius: 4}}>
                <CameraModal
                    open={open}
                    onClose={() => setOpen(false)}
                    onCapture={(image) => {
                        setItem(prev => ({ ...prev, image }));
                        setPreview(image);
                    }}
                />
                
                <BarcodeScanner
                    open={scannerOpen}
                    onClose={() => setScannerOpen(false)}
                    onScan={handleBarcodeScanned}
                />

                <Typography sx={{ fontWeight: 600, fontSize: 18 }}>What are you selling today?</Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, height: "100%"}}>
                    <Box>
                        <Typography sx={{fontWeight: 600}}>Product Name:</Typography>
                        <TextField value={item.name} onChange={(e)=>{handleChange(e, 'name')}} placeholder="Product Name" fullWidth/>
                    </Box>
                    
                    <Box>
                        <Typography sx={{fontWeight: 600}}>Barcode:</Typography>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <TextField 
                                value={item.barcode} 
                                onChange={(e)=>{handleChange(e, 'barcode')}} 
                                placeholder="Scan or enter barcode" 
                                fullWidth
                            />
                            <Button 
                                onClick={() => setScannerOpen(true)}
                                variant="outlined"
                                sx={{ 
                                    minWidth: 'auto',
                                    px: 2,
                                    borderRadius: 2
                                }}
                            >
                                <QrCodeScannerIcon />
                            </Button>
                        </Box>
                    </Box>

                    <Box>
                        <Typography sx={{fontWeight: 600}}>Product Price:</Typography>
                        <TextField value={item.price} onChange={(e)=>{handleChange(e, 'price')}} placeholder="Price" fullWidth/>
                    </Box>

                    <Box>
                        <Typography sx={{ fontWeight: 600, mb: 1 }}>Product Image (Optional):</Typography>
                        {preview ? (
                            <Box 
                                component="img" 
                                src={preview} 
                                sx={{ 
                                    width: "100%", 
                                    borderRadius: 2, 
                                    cursor: "pointer",
                                    maxHeight: "200px",
                                    objectFit: "cover"
                                }}
                                onClick={() => setOpen(true)}
                            />
                        ) : (
                            <Box 
                                sx={{
                                    display: "flex", 
                                    justifyContent: "center", 
                                    border: 2, 
                                    borderRadius: 2, 
                                    borderColor: "primary.main", 
                                    py: 6,
                                    cursor: "pointer"
                                }} 
                                onClick={() => setOpen(true)}
                            > 
                                <Box sx={{display: "flex", flexDirection: "column", textAlign: "center"}}>
                                    <CameraAltOutlinedIcon sx={{fontSize: 40, color: "primary.main", margin: "auto"}}/>
                                    <Typography sx={{fontSize: "10px", color: "primary.main" }}>Capture Product Image</Typography>
                                </Box>
                            </Box>
                        )}
                    </Box>

                    <Box sx={{display: "flex", gap: 2, mt: 2}}>
                        <Box onClick={()=>{setModal(false)}} sx={{textAlign: "center", width: "100%", bgcolor: "#e2e2e2ff", p: 2, boxShadow: "none", borderRadius: 2, cursor: "pointer"}}>Close</Box>
                        <Button onClick={handleAddProduct} fullWidth variant="contained" sx={{p: 2, boxShadow: "none", borderRadius: 2}}>Save Item</Button>  
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}